<div class="container team-news top-space-only-desktop">
  <div class="row">
    <div class="col-md-7">
      <div class="row ml-0 mr-0" *ngIf="!isLoading; else loading">
        <mat-tab-group
          mat-align-tabs="start"
          class="team-news-tabs"
          dynamicHeight
          [selectedIndex]="showAllGames === true ? 1 : 0"
          (selectedTabChange)="changeRoute($event)">
          <mat-tab label="Meine Spiele">
            <ng-template matTabContent>
              <ng-container *ngTemplateOutlet="datePicker"></ng-container>
              <app-my-games [selectedDate]="selectedDate"></app-my-games>
            </ng-template>
          </mat-tab>
          <mat-tab label="Alle Spiele">
            <ng-template matTabContent>
              <ng-container *ngTemplateOutlet="datePicker"></ng-container>
              <app-all-games [selectedDate]="selectedDate" [user]="user"></app-all-games>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div class="col-md-5 d-none d-md-block parent-sticky">
      <div class="row sticky">
        <div class="col-md-12" *ngIf="isLoading === false">
          <lib-league-table [smallTable]="true" [league]="selectedLeagueInAllMatches"></lib-league-table>
        </div>
        <lib-ad class="col-md-12"></lib-ad>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="container mb-1 mt-1">
    <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
  </div>
</ng-template>

<ng-template #datePicker>
  <div class="dates-filter-wrapper">
    <div id="datePicker" class="time-button-wrapper">
      <a *ngFor="let date of datesForSelection" class="mr-1 date-button mat-stroked-button"
         [class.today]="isSameDay(date, today)" [routerLink]="getLinkForDate(date)"
         routerLinkActive="active" (click)="selectDate(date)">
        <b>{{ isSameDay(date, today) ? 'Heute' : (date | date: 'E').replace('.', '') | uppercase }}</b>
        <br>{{ date | date: 'd. MMM' }}
      </a>
    </div>
  </div>
</ng-template>
